import API from 'src/api'
import { http } from '../boot/axios'

const URL = `${API.GRAPHQL_URL}home-configuration`

const DEFAULTS = {
  modules:   ['forms', 'reports', 'agenda'],
  shortcuts: ['task_mine', 'report_general', 'report_incidents', 'agenda_event'],
  newsView:  'default'
}

export default {
  fetch () {
    return new Promise((resolve, reject) => {
      http.get(URL)
        .then(res => {
          const data = res.data.data
          resolve({
            modules:   data.module.length   ? data.module    : DEFAULTS.modules,
            shortcuts: data.shortcut.length ? data.shortcut  : DEFAULTS.shortcuts,
            newsView:  data.news_view       ? data.news_view : DEFAULTS.newsView
          })
        })
        .catch(error => reject(error))
    })
  },

  save ({ modules, shortcuts, newsView }) {
    return new Promise((resolve, reject) => {
      http.post(`${URL}/save`, {
        modules,
        shortcuts,
        news_view: newsView
      })
        .then(res => resolve(res.data))
        .catch(error => reject(error))
    })
  }
}
